var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#015ABC",
    d: "M2.5 2.5H37.5V37.5H2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#015ABC",
    d: "M37,3v34H3V3H37 M38,2H2v36h36V2L38,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5ACD0",
    d: "M8 16.077L13.538 16.077 13.538 27.085 13.538 32 8 32zM10.769 14.462L10.769 14.462C9.108 14.462 8 13.285 8 11.831s1.108-2.562 2.769-2.562 2.7 1.108 2.769 2.562C13.538 13.285 12.5 14.462 10.769 14.462zM32.027 32h-5.468c0 0 0-8.27 0-8.885s-.068-2.734-2.392-2.734c-2.05 0-2.392 1.982-2.392 2.734s0 8.885 0 8.885h-5.468V16.281h5.468v2.119c0 0 1.094-2.119 4.306-2.119 3.281 0 5.946 2.255 5.946 6.834V32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ff3b3daee70fc7bbf7e329f7650c416f.svg";
export { ForwardRef as ReactComponent };